import { IPagination } from 'app/types/common';

export interface IPaymentCollectionsState {
  readonly paymentCollectionsById?: any;
  readonly paymentCollectionIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectPaymentCollectionLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddPaymentCollection?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationpaymentCollectionIds?: string[];
  readonly currentPaymentCollectionId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPaymentCollectionsSelector extends IPaymentCollectionsState {
  readonly currentPaymentCollection?: any;
  readonly currentFormPaymentCollection?: any;
  readonly getPaymentCollectionsFilteredByTagInSelectFormat?: any;
  readonly paymentCollectionsByIdInSelectFormat?: any;
}

export enum PaymentCollectionsActionTypes {
  GET_ALL_PAYMENT_COLLECTIONS_REQUESTED = 'redux-app/payment-collections/GET_ALL_PAYMENT_COLLECTIONS_REQUESTED',
  GET_ALL_PAYMENT_COLLECTIONS_PENDING = 'redux-app/payment-collections/GET_ALL_PAYMENT_COLLECTIONS_PENDING',
  GET_ALL_PAYMENT_COLLECTIONS_SUCCESS = 'redux-app/payment-collections/GET_ALL_PAYMENT_COLLECTIONS_SUCCESS',
  GET_ALL_PAYMENT_COLLECTIONS_FAIL = 'redux-app/payment-collections/GET_ALL_PAYMENT_COLLECTIONS_FAIL',
  GET_PAYMENT_COLLECTION_REQUESTED = 'redux-app/payment-collections/GET_PAYMENT_COLLECTION_REQUESTED',
  GET_PAYMENT_COLLECTION_PENDING = 'redux-app/payment-collections/GET_PAYMENT_COLLECTION_PENDING',
  GET_PAYMENT_COLLECTION_SUCCESS = 'redux-app/payment-collections/GET_PAYMENT_COLLECTION_SUCCESS',
  GET_PAYMENT_COLLECTION_FAIL = 'redux-app/payment-collections/GET_PAYMENT_COLLECTION_FAIL',
  SELECT_PAYMENT_COLLECTION_REQUESTED = 'redux-app/payment-collections/SELECT_PAYMENT_COLLECTION_REQUESTED',
  CLEAR_PAYMENT_COLLECTIONS = 'redux-app/payment-collections/CLEAR_PAYMENT_COLLECTIONS',
}

export interface IPaymentCollection {
  id: string;
  status: string;
  description: string;
  amount: number;
  metadata: any;
  organisation: any;
  competition: any;
  group: any;
  person: any;
  createdAt: Date;
  updatedAt: Date;
  purchasedAt?: any;
  dueAt: Date;
  friendlyReference: string;
  secureReference: string;
  payByTextEnabled: boolean;
  payByTextCode?: any;
  amountWithFee: number;
  paymentCollectionType: string;
  paymentType: string;
  paymentCategory: string;
  externalGatewayId: string;
  notificationLog?: any;
  personName: string;
  groupName: string;
  groupSectionName: string;
  groupSeasonName: string;
  paymentRequest: any;
}

export default null;
